define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action",
	"csi/action/Controller",
	"csi/action/FormData",
	"csi/comm/PostRequest",
	"csi/core/extendedPathService",
	"csi/def/ViewRef",
	"csi/html",
	"csi/locale",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query"
], function (declare, lang, _, csiAction, Controller, FormData, PostRequest, {parseExtendedPath}, ViewRef, html, locale, ActionControllerMixin, xml, Query) {

	const ACTION_REPLACE = "Replace";
	const ACTION_APPEND = "Append";
	const ACTION_NEXT = "NextPage";
	const PRODUCT_SOURCE = "ProductSource";

	const PRODUCT_TYPE = "ProductType";

	return declare([Controller, ActionControllerMixin], {
		_fdProducts: null,
		_fdSections: null,
		_fdBoms: null,
		_inlineSection: null,

		addProxyActions: function (/*View*/defView, /*Actions*/defActions) {
			// summary: if creating new node, then add Save & New action as well
			defActions.addAction(this.getProxyAction("PrevPage"));
			defActions.addAction(this.getProxyAction(ACTION_NEXT, false, {m_class: html.CSS_BUTTON_SECONDARY}));
			defActions.addAction(this.getProxyAction(ACTION_REPLACE, false, {m_name: locale.resource(ACTION_REPLACE)}), 2);
			defActions.addAction(this.getProxyAction(ACTION_APPEND, false, {
				m_name: locale.resource(ACTION_APPEND),
				m_class: html.CSS_BUTTON_SECONDARY
			}));
			Controller.prototype.addProxyActions.call(this, defView, defActions);
		},

		getWizardViewQuery: function (/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			const q = new Query();

			index = this._getIndexBasedOnAction(index);

			const bomParentType = this.getContext().cache.getPathNode(this.m_urlParent, "Child:__Parent__/Child:__Parent__")?.$Type;

			// we only need to check product type for Products page
			if (index === 1 && bomParentType !== "Theme") {
				let productTypes = [];

				if (this._inlineSection) {
					// if section is adhoc, there are no rules, so show everything.
					productTypes = !this._inlineSection.AdHoc ? this._inlineSection.BOMProductTypes : null;
				} else {
					const sections = this._fdSections.getSelectedNodes();

					$.each(sections, function (index, section) {
						if (section.AdHoc || _.isEmpty(section.BOMProductTypes)) {
							productTypes = null;
							// if section is adhoc, there are no rules, so we show everything. So return false to break the loop.
							return false;
						}
						productTypes = _.union(productTypes, section.BOMProductTypes);
					});
				}

				let path;
				if (bomParentType === PRODUCT_SOURCE) {
					path = "Child:LinkedHostDataSheet/Child:__Parent__";
				}
				if (!_.isEmpty(productTypes)) {
					_.each(productTypes, function (productType) {
						this.RefAttr(PRODUCT_TYPE, xml.OP_EQUALS, productType, path);
					}, q.Or());
				}
			}

			if (index === 2) {
				const bomRevision = this.getParent();
				if (bomRevision) {
					// we should exclude the current BOM.
					q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, bomRevision.__Parent__);
				}
			}

			return q;
		},

		preProcess: function () {
			// summary: cache form data for later
			this._fdSections = this.getFormData();
			this._fdProducts = new FormData(this);
			this._fdBoms = new FormData(this);

			this._fdSections.m_bRequireOne = true;
			this._fdProducts.m_bRequireOne = true;

			this._inlineSection = null;
			const qr = this.widget.getQueryResultByDomNode(this.refNode);

			if (qr) {
				const groupValue = qr.groupValue;
				if (xml.isValidURL(groupValue)) {
					const bomSectionDef = this.m_cache.getNode(groupValue);

					if (bomSectionDef.$Type === "BOMSectionDefinition") {
						this._inlineSection = bomSectionDef;
					}
				}
			}

			const rev = this.m_cache.getNode(this.widget.urlRoot);
			const bomParentType = this.getContext().cache.getPathNode(rev, "Child:__Parent__/Child:__Parent__")?.$Type;
			let viewRef;

			if (bomParentType === "Theme") {
				viewRef = this._inlineSection ? "PushSingleThemeBOMSectionWizard" : "PushThemeBOMSectionsWizard";
				this.m_action.m_viewRef = lang.mixin(new ViewRef(), {
					m_id: viewRef
				});
				this.idWizardResource = this._inlineSection ? "BomSectionMenuPushSingle_Theme" : "BomSectionMenuPush_Theme";
			} else if (bomParentType === PRODUCT_SOURCE) {
				viewRef = this._inlineSection ? "PushSingleSharedBOMSectionWizard" : "PushSharedBOMSectionWizard";
				this.m_action.m_viewRef = lang.mixin(new ViewRef(), {
					m_id: viewRef
				});
				this.idWizardResource = "BomSectionMenuPush_ToShared";
			} else if (rev.$Type === "MaterialBOMRevision") {
				viewRef = this._inlineSection ? "PushSingleMaterialBOMSectionWizard" : "PushMaterialBOMSectionsWizard";
				this.m_action.m_viewRef = lang.mixin(new ViewRef(), {
					m_id: viewRef
				});
				this.idWizardResource = this._inlineSection ? "BomSectionMenuPushSingle_Material" : "BomSectionMenuPush_Material";
			} else if (rev.$Type === "ApparelBOMRevision") {
				viewRef = this._inlineSection ? "PushSingleApparelBOMSectionWizard" : "PushApparelBOMSectionsWizard";
				this.m_action.m_viewRef = lang.mixin(new ViewRef(), {
					m_id: viewRef
				});

				this.idWizardResource = this._inlineSection ? "BomSectionMenuPushSingle_Apparel" : "BomSectionMenuPush_Apparel";
			}

			this.inherited(arguments);
		},

		process: function () {
			// summary: issue request so as to be able to receive return value
			const req = this.m_action.m_request;

			this.setProgress();

			const submitButtonName = this.m_proxy.m_action.m_id;

			const fd = this.m_formData;
			const productBomRev = this.m_cache.getNode(this.widget.urlRoot);
			const productBom = this.m_cache.getNode(productBomRev.Master);

			new PostRequest(req.m_module, req.m_operation)
				.addParameter(xml.PROP_URL_PARENT, this.m_urlParent)
				.addParameter(xml.PROP_AGGREGATE_ADDS, this._inlineSection ? [xml.nodeGetURL(this._inlineSection)] : fd.getSelectedValue())
				.addParameter("TargetProducts", this._fdProducts.getSelectedValue())
				.addParameter("TargetBOMs", this._fdBoms.getSelectedValue())
				.addParameter(xml.ATTR_NAME, locale.type(xml.nodeGetType(productBom)))
				.addParameter("Replace", submitButtonName === ACTION_REPLACE)
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		},

		onNextPage: function (/*csi.wizard.Widget*/wizard,
									 /*csi.wizard.Content*/currentPage,
									 /*csi.wizard.Content*/nextPage,
									 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			let bRefresh = false;
			let dfd;
			let fd;

			if (nextPage) {
				const index = this._getIndexOfPage(wizard, nextPage);

				if (index === 0) {
					fd = this._fdSections;
				} else {
					const rev = this.m_cache.getNode(this.widget.urlRoot);
					const bomParentType = this.getContext().cache.getPathNode(rev, "Child:__Parent__/Child:__Parent__")?.$Type;

					if (index === 1 && bomParentType === PRODUCT_SOURCE) {
						fd = this._fdBoms;
					} else if (index === 1) {
						fd = this._fdProducts;
					} else {
						fd = this._fdBoms;
					}

					// Checking two arrays if they're equal is expensive. Instead we'll just reset the selection every time user click next button
					fd.resetSelections();
					bRefresh = true;
				}

				if (fd) {
					dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
				}
			}

			return dfd;
		},

		_getIndexOfPage: function (wizard, nextPage) {
			// summary: to avoid adding many if-else statements for inline and not inline behavior, we can just return page index + 1
			// for inline. Because for inline, we don't have the first page, so if we just return 1 for first page and 2 for second page,
			// the rest of this controller's logic will work.
			const index = wizard.getIndexOfPage(nextPage);
			return this._getIndexBasedOnAction(index);
		},

		_getIndexBasedOnAction: function (index) {
			return this._inlineSection ? index + 1 : index;
		},

		onWizardViewPreCreate: function (/*csi.wizard.Widget*/wizard, /*Content*/page, /*View*/defView, /*Object*/viewParams) {
			var index = wizard.getIndexOfPage(page);

			const bomParent = this.m_cache.getPathNode(this.m_urlParent, "Child:__Parent__/Child:__Parent__");

			if (index === 0) {
				if (bomParent?.$Type === "Theme" && this.m_action.m_id === "BomSectionPush") {
					const key = xml.queryKey(xml.ATTR_NAME, null, xml.path("__Parent__"));
					const themeMaster = this.m_cache.getPathNode(bomParent, "Child:__Parent__");
					viewParams.query = {[key]: [themeMaster.$Name]};
				}
				viewParams.relativePaths = [
					parseExtendedPath("(ApparelBOMRevision)Child:__Parent__(ApparelBOM)/Child:__Parent__(Style)")
				];
			}

			if (index === 1 && bomParent?.$Type === "Theme" && this.m_action.m_id === "BomSectionMenuPush") {
				const key = xml.queryKey(xml.ATTR_NAME, null, xml.path("__Parent__"));
				const themeMaster = this.m_cache.getPathNode(bomParent, "Child:__Parent__");
				viewParams.query = {[key]: [themeMaster.$Name]};
			}

			if (this._getIndexOfPage(wizard, page) === 2) {
				const self = this;

				viewParams.onCreateMainQueryLevel = function (ql) {
					const selectedValues = self._fdProducts.getSelectedValue();

					if (selectedValues && selectedValues.length > 0) {
						const paths = [];
						_.each(selectedValues, function (selectedValue) {
							paths.push(xml.getUrlPath(selectedValue, xml.path("DataSheets")));
						});

						ql.requestParameters["Qry.Limit.Path"] = paths;
					}
				};
			}
		},

		getString: function (/*String*/suffix, /*String[]?*/params) {
			let string = this.inherited(arguments);

			if (suffix === csiAction.SUFFIX_SUCCESS) {
				params = this.getStringParameters();

				if (params && params.length === 3 && params[2] != 0)
					string += " " + locale.resourceIfExists(this.m_action.m_id + "_Ignored", [params[2]]);
			}

			return string;
		}

	});
});